export const SLI_EVENT_TYPE = 'sli';

export const SMART_EVENT_TYPE = 'smart';

// OLD Analytics
export const MENTION_ANALYTICS_PREFIX: any = 'atlassian.fabric.mention';
